<template>
  <CustomContainer
    :no-background-color="false"
    :border-hidden="false"
    padding="p-4"
    class="cursor-pointer existing_contact_container"
    @click="handleClick"
  >
    <div class="flex flex-row justify-between items-start w-full">
      <div class="flex flex-row gap-3 items-center">
        <ProfileIcon :data="profileData" :size="40" />
        <div class="flex flex-col text_color">
          <span class="text-base font-semibold text_color">{{ displayName }}</span>
          <span v-if="displaySubtitle" class="text-xs font-normal">{{ displaySubtitle }}</span>
        </div>
      </div>
      <div>
        <ThemeImage
          class="size-4"
          :icon="imageNames.GO_TO_LINK_GREY"
          alt="go_to_record"
        />
      </div>
    </div>
  </CustomContainer>
</template>

<script setup>
import ProfileIcon from "@/src/components/ProfileIcon.vue";
import CustomContainer from "@/src/components/CustomContainer.vue";
import { defineProps, computed } from "vue";
import { useRouter } from "vue-router";
import { imageNames } from "@/src/constants/imageConstants.js";
import { entityTypes } from "@/src/constants/entityTypeConstants.js";
import { getEntityDisplayName } from "@/src/utils/entityUtils.js";

const router = useRouter();

const props = defineProps({
  existingEntity: { type: Object, required: false },
  source: String,
  objectSlug: { type: String, default: null },
    primaryAttributeSlug: { type: String, default: null },
  secondaryAttributeSlug: { type: String, default: null },
});

const isCustomObject = computed(() => {
  return props.objectSlug && !isStandardEntity.value;
});

const isStandardEntity = computed(() => {
  const standardTypes = [
    entityTypes.CONTACT,
    entityTypes.LEAD,
    entityTypes.COMPANY,
    entityTypes.DEAL,
  ];
  return standardTypes.includes(props.source);
});


const displayName = computed(() => {
  return getEntityDisplayName(props.existingEntity, props.primaryAttributeSlug) || "Unnamed Record";
});


const displaySubtitle = computed(() => {
  if (!props.existingEntity) return "";


  if (isCustomObject.value && props.secondaryAttributeSlug) {
    const attributes = props.existingEntity.attributes || {};
    const attrValue = attributes[props.secondaryAttributeSlug];
    if (attrValue && typeof attrValue === "object" && attrValue.value !== undefined) {
      return attrValue.value || "";
    }
    return attrValue || "";
  }


  return props.existingEntity.email || "";
});


const profileData = computed(() => {
  if (isCustomObject.value) {

    return {
      name: displayName.value,
      ...props.existingEntity,
    };
  }
  return props.existingEntity;
});

const handleClick = () => {
  if (!props.existingEntity?.id) return;

  if (isCustomObject.value && props.objectSlug) {
    router.push(`/crm/${props.objectSlug}/${props.existingEntity.id}`);
  } else {
    let route = props.source;
    
    if (!route.endsWith('s')) {
      if (route === 'company') {
        route = 'companies';
      } else {
        route = `${route}s`;
      }
    }
    
    router.push(`/${route}/${props.existingEntity.id}`);
  }
};
</script>

<style scoped>
.existing_contact_container {
  transition: background-color 0.2s ease;
}

.existing_contact_container:hover :deep(.custom_container) {
  background-color: var(--white-opacity-8);
}
</style>
